import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5bd8a23a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=5bd8a23a&lang=scss&"
import style1 from "./index.vue?vue&type=style&index=1&id=5bd8a23a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd8a23a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bd8a23a')) {
      api.createRecord('5bd8a23a', component.options)
    } else {
      api.reload('5bd8a23a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5bd8a23a&scoped=true&", function () {
      api.rerender('5bd8a23a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/resetPassword/index.vue"
export default component.exports